import React from "react";
import {
  Dialog,
  DialogContent,
  Typography,
  Button,
  Box,
} from "@mui/material";
import Bronze from '../../assets/game/bronze-medal.png'
import Silver from '../../assets/game/Sliver.png'
import Gold from '../../assets/game/Gold.png'
import Platinum from '../../assets/game/Platinum.png'
const LoyaltyCongratsDialog = ({ open=true, onClose ,milestoneData}) => {

console.log("miltestone----",milestoneData)

const levelMap = {
  1: "Bronze",
  2: "Silver",
  3: "Gold",
  4: "Platinum",
};
const medalMap = {
  1: Bronze,
  2: Silver,
  3: Gold,
  4: Platinum,
};
const medalImage = medalMap[milestoneData?.level] || Bronze;
const levelName = levelMap[milestoneData?.levelId] || "Bronze";
  return (
   <Dialog
  open={open}
  
  PaperProps={{
    sx: {
      overflow: "visible", // ⭐ IMPORTANT
      borderRadius: "16px",
    
    },
  }}
>
<DialogContent
  sx={{
    textAlign: "center",
    pt: 6, // ⭐ space for floating medal
    pb: 4,
    px: 4,
  }}
>
      
        {/* Medal Image */}
 <Box
  sx={{
    position: "absolute",
    top: -50,
    left: "50%",
    transform: "translateX(-50%)",
    width: 90,
    height: 90,
    borderRadius: "50%",
 
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    
    zIndex: 10,
  }}
>
  <img
    src={medalImage}
    alt="medal"
    
   
  />
</Box>

        {/* Spacer for top overlap */}
        <Box sx={{ height: 30 }} />

        {/* Title */}
        <Typography variant="h6" fontWeight="bold" gutterBottom>
          Congratulations
        </Typography>

        {/* Subtitle */}
        <Typography variant="body2" color="text.secondary" mb={3}>
          You've unlocked the {levelName} Level. Keep going to earn even bigger rewards.
        </Typography>

        {/* Button */}
        <Button
          fullWidth
          variant="contained"
          onClick={onClose}
          sx={{
            backgroundColor: "#12a76c",
            borderRadius: "30px",
            py: 1.2,
            textTransform: "none",
            fontSize: "16px",
            "&:hover": {
              backgroundColor: "#0e8f5a",
            },
          }}
        >
          Ok
        </Button>
      </DialogContent>
    </Dialog>
  );
};

export default LoyaltyCongratsDialog;